import React from "react";

const DisbursingModal = ({ isOpen }) => {
  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 px-4"
      role="dialog"
      aria-labelledby="disbursing-title"
      aria-modal="true"
    >
      <div className="bg-white w-full max-w-md md:max-w-md p-6 rounded-lg shadow-lg text-center">
        <div className="flex justify-center">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="60"
            height="60"
            viewBox="0 0 24 24"
            className="animate-pulse"
          >
            <circle cx="18" cy="12" r="0" fill="#000">
              <animate
                attributeName="r"
                begin=".67s"
                dur="1.5s"
                values="0;3;0"
                repeatCount="indefinite"
              />
            </circle>
            <circle cx="12" cy="12" r="0" fill="#000">
              <animate
                attributeName="r"
                begin=".33s"
                dur="1.5s"
                values="0;3;0"
                repeatCount="indefinite"
              />
            </circle>
            <circle cx="6" cy="12" r="0" fill="#000">
              <animate
                attributeName="r"
                begin="0s"
                dur="1.5s"
                values="0;3;0"
                repeatCount="indefinite"
              />
            </circle>
          </svg>
        </div>
      </div>
    </div>
  );
};

export default DisbursingModal;
